// extracted by mini-css-extract-plugin
module.exports = {"total":"_1Fce8I","price":"_9G_Sbz"};